import { getImage2VideoResult } from './aiImageToVideo';

export async function downloadImageToVideo({
  previewUrl,
  taskId,
  fileName = 'image-to-video.mp4',
}: {
  previewUrl?: string | null;
  taskId?: string | null;
  fileName?: string;
}) {
  let url: string | null = null;
  let blobUrlToRevoke: string | null = null;

  if (taskId) {
    const result = await getImage2VideoResult(taskId);
    if (result.kind !== 'done') {
      throw new Error('Video is not ready yet');
    }
    const blobUrl = URL.createObjectURL(result.blob);
    url = blobUrl;
    blobUrlToRevoke = blobUrl;
  } else if (previewUrl) {
    // Fallback for locally uploaded videos that only exist as a blob URL
    url = previewUrl;
  }

  if (!url) {
    throw new Error('No video available to download');
  }

  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  if (blobUrlToRevoke) {
    URL.revokeObjectURL(blobUrlToRevoke);
  }
}
